// export const _serverurl =
// "https://us-central1-test-git-ci-6ea81.cloudfunctions.net/client/"; //cloud development
export const _serverurl ="https://us-central1-bunkbread-production.cloudfunctions.net/client/"; //cloud development
// export const _serverurl ="http://localhost:5000/test-git-ci-6ea81/us-central1/client/"; //localhost development
// export const _serverurl =
// "https://us-central1-test-git-ci-6ea81.cloudfunctions.net/client/";  //cloud development
//export const _serverurl ="http://localhost:5001/bunkbread-production/us-central1/client";